// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyMessage-root-fcae0e843321cbcbf0487ebbb91fa17b"};